import store from '@/vuex/store'
import { isBulkSlideAddSupported } from '@/services/office/insert-slides'
import { canReadSlideTags } from '@/services/office/slide-tags'

// AHA-46329: the multi-slide selector needs the flag AND a PowerPoint that can do both halves
// of the flow. An unsupported host (iPad, volume-licensed perpetual Office incl. 2024 LTSC)
// must never reach the selector, because the Add button there could not do anything — so those
// users silently keep the original flow.
//
// The two capabilities are checked separately because they are two different dependencies:
//   - exportAsBase64 (1.8) — the donor export the clone trick depends on, i.e. can we INSERT?
//   - TagCollection (1.3) — the per-slide binding every inserted slide gets, i.e. can the
//     inserted slides be TOLD APART afterwards? An insert whose slides cannot be tagged is
//     worse than no insert: the clones all inherit one binding and render the same slide.
// On a spec-compliant host requirement sets are monotonic, so 1.8 already implies 1.3 and the
// second check never changes the answer. It is here so the gate states what it actually needs
// instead of leaning on that arithmetic — and so a host that reports the sets non-monotonically
// (or a shimmed/partial Office.js) fails the gate rather than reaching a half-working selector.
//
// This is its own module on purpose: services/office/index.js needs it, and importing it
// from ppt-select-presentation.js (which imports @/services/office) would be circular.
export const canUsePptSlideSelector = () => {
  return Boolean(store.getters['featureToggles/canUsePptMultipleSelect'])
    && isBulkSlideAddSupported()
    && canReadSlideTags()
}

// AHA-46754: same host requirement, plus its own flag, for the ROW-BODY route into the
// selector — a click on a list row anywhere other than its "Select presentation" button.
// The getter already ANDs in AHA-46329, so this stays a strict subset of
// canUsePptSlideSelector(): with AHA-46754 off the button keeps opening the selector and
// the rest of the row goes back to what it did before AHA-46329 (inert row; thumbnail and
// name cells open the editor).
export const canUsePptRowClickSelector = () => {
  return Boolean(store.getters['featureToggles/canUsePptPrezListRowClick']) && isBulkSlideAddSupported()
}
